// @flow
import 'regenerator-runtime/runtime';
import run from './';

run();
